import { render, staticRenderFns } from "./RolesForm.vue?vue&type=template&id=497d959c&scoped=true"
import script from "./RolesForm.vue?vue&type=script&lang=js"
export * from "./RolesForm.vue?vue&type=script&lang=js"
import style0 from "./RolesForm.vue?vue&type=style&index=0&id=497d959c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497d959c",
  null
  
)

export default component.exports